module.exports = __webpack_public_path__ + "img/favicon-96x96.7782be1c.png";